'use client'

import React from 'react'
import { Box, Heading, Image, Text } from '@chakra-ui/react'
import { Article } from '@leid/api-articles'
import { format } from 'date-fns'

import { getDateFormatLocale } from 'utils/getDateFormatLocale'

type Props = {
  article: Article
}

const ArticleContent = ({ article }: Props): JSX.Element => {
  const decodeHtml = (html: string): string => {
    return html.replace(/&lt;iframe[\s\S]*?&lt;\/iframe&gt;/g, (match) => {
      const doc = new DOMParser().parseFromString(match, 'text/html')
      return doc.documentElement.textContent ?? ''
    })
  }

  const decodedHtml = decodeHtml(article.body ?? '')

  return (
    <>
      <Image
        src={article.image || '/article-big.png'}
        borderRadius="9px"
        marginX="auto"
        marginBottom={{ base: '20px', lg: '56px' }}
        marginTop={{ lg: '64px' }}
        maxWidth="794px"
        width="100%"
      />
      <Box maxWidth="590px" marginX="auto">
        <Heading
          fontSize={{ base: 'md', lg: '2xl' }}
          marginBottom={{ base: '2px', lg: '16px' }}
          lineHeight={{ base: '24px', lg: '48px' }}
          fontWeight="normal"
        >
          {article.title}
        </Heading>
        <Text fontSize="xs" fontWeight={600}>
          {article.fullName}
        </Text>

        <Text fontSize="xs" color="green.a200">
          {format(new Date(article.updatedAt || ''), 'dd.MM.yyyy', { locale: getDateFormatLocale() })}
        </Text>

        <Box margin={{ base: '8px 0 42px 0', lg: '48px auto 64px auto' }}>
          {article?.body && (
            <Box
              css={{
                '& p': { fontWeight: 300 },
                '& li': { fontWeight: 300 },
                '& a': { color: 'blue', textDecoration: 'underline' },
                '& img': {
                  margin: { base: '28px auto 14px auto', lg: '48px auto 24px auto' },
                },
                '& .ql-align-center': {
                  textAlign: 'center',
                },
                '& .ql-align-right': {
                  textAlign: 'right',
                },
                '& .ql-align-justify': {
                  textAlign: 'justify',
                },
              }}
              dangerouslySetInnerHTML={{ __html: decodedHtml ?? '' }}
            />
          )}
        </Box>
      </Box>
    </>
  )
}

export default ArticleContent
